module.exports = {
      id: "kishoralo-usage",
      viewBox: "0 0 512 209.434",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#kishoralo",
      toString: function () {
        return this.url;
      }
    }